<template>
    <div class="class-list p-b-64 page">
        <div style="padding-bottom: 70px">
            <div v-if="$route.query.type == 1"
                 style="font-size: 14px; color: #ff9e00; padding: 15px 15px; background-color: #fafafa">
                审批单将跳过剩余审批节点，直接通过审批
            </div>

            <van-cell
                v-if="$route.query.type == 2"
                title="驳回到"
                :required="true"
                arrow-direction="down"
                @click.native="showPicker()"
                is-link>
                <template slot>
                    <div v-if="refuseTarget.label">{{refuseTarget.label}}</div>
                    <div v-else style="color: #a4afbc">请选择</div>
                </template>
            </van-cell>
            <div style="height: 5px"></div>
            <van-cell
                title="审批意见"
                :required="opinionRequired"></van-cell>
            <van-field
                v-model="opinionRemind"
                placeholder="请输入审批意见"
                type="textarea"/>
        </div>

        <div class="m-l-12 m-r-12" style="position: fixed; bottom: 12px; left: 0px; right: 0px; ">
            <van-button
                style="background-color: #3388ff; color: white; width: 100%" @click.native="commit()">确定
            </van-button>
        </div>
    </div>
</template>

<script>
    import head from '../../mixins/head';
    import componnetInitValue from '../../mixins/component';
    import componentHybird from '../../mixins/component-hybird';

    export default {
        components: {},
        name: 'flow-force-commit',
        mixins: [head, componnetInitValue, componentHybird],
        data() {
            return {
                opinionRemind: '',
                opinionRequired: true,
                data: {},
                refuseTarget: '',
                refuseList: [],
                picker: ''
            };
        },
        props: {},
        computed: {},
        created() {
            window.moreButton({});
            this.init();
        },
        mounted() {
        },
        methods: {

            init() {
                if (this.$route.query.type == 2) {
                    this.getData();
                }
            },

            //获取详情数据
            getData() {
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {
                    id: this.$route.query.id
                };
                this.$http.post('badu/eaa/queryApproveWorkFlowDetail_V2.do', param, { toast: true })
                    .then((response) => {
                        this.$toast.clear();
                        this.data = response.data;
                        let nodes = _.uniqBy(this.data.historyProcess, 'nodeId');
                        for (let j = 0; j < nodes.length; j++) {
                            let node = nodes[j];
                            this.refuseList.push({
                                text: node.remark,
                                value: {
                                    nodeSort: node.nodeSort,
                                    nodeId: node.nodeId
                                }
                            });
                        }
                        console.log('refuseList', this.refuseList);
                    })
                    .catch((error) => {
                        console.log(error);
                        this.$toast.clear();
                        this.$toast.fail({
                            forbidClick: true,
                            message: '获取审批数据异常'
                        });
                        setTimeout(() => {
                            if (window.history.length == 1) {
                                // this.REPLACE({ name: 'approve' });
                                window.closeWindow();
                            } else {
                                this.GO(-1);
                            }
                        }, 2000);
                    });
            },

            showPicker() {
                // if (/(BD-ANDROID)/i.test(navigator.userAgent) || /(BD-IOS)/i.test(navigator.userAgent)) {
                //     let extra = {
                //         refuseTarget: true
                //     };
                //     window.pickSingle(this.refuseList, this.refuseTarget ? {
                //         text: this.refuseTarget.label,
                //         value: this.refuseTarget.targetNodeSort
                //     } : '', extra);
                // } else {
                if (!this.picker) {
                    this.picker = this.$createPicker({
                        data: [this.refuseList],
                        onSelect: (selectedVal, selectedIndex, selectedText) => {
                            this.refuseTarget = {
                                label: selectedText[0],
                                targetNodeSort: selectedVal[0].nodeSort,
                                targetNodeId: selectedVal[0].nodeId
                            };
                        },
                        onCancel: () => {
                        }
                    });
                }
                this.picker.show();
                // }
            },

            commit() {
                if (this.$route.query.type == 1) {
                    this.forcedEndConfirm(this.opinionRemind);
                } else {
                    let commitData = this.loopCondition(this.data.temp.conditions, JSON.parse(this.data.content));
                    console.log('commitData', commitData);
                    this.refuse(commitData.condition, commitData.hrProperty);
                }
            },

            //驳回审批
            refuse(condition, hrProperty) {
                console.log('refuse', this.refuseTarget);
                if (!this.refuseTarget) {
                    this.$toast.fail({
                        duration: 1000,
                        forbidClick: true,
                        message: '请选择驳回路线'
                    });
                    return;
                }
                if (!this.opinionRemind.trim()) {
                    this.$toast.fail({
                        duration: 1000,
                        forbidClick: true,
                        message: '请填写审批意见'
                    });
                    return;
                }
                let targetNodeSort = this.refuseTarget.targetNodeSort;
                if (targetNodeSort == 1) {
                    targetNodeSort = 0;
                }
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {
                    id: this.$route.query.id,
                    nodeSort: this.data.currentNodeSort,
                    targetNodeSort: targetNodeSort,
                    reason: this.opinionRemind,
                    params: JSON.stringify(condition),
                    hrProperty: JSON.stringify(hrProperty)
                };
                this.$http.post('badu/eaa/managementRefuseApproveWorkFlow_V2.do', param).then((response) => {
                    this.$toast.clear();
                    if (response.rspCode == 0) {
                        this.opinionRemind = '';
                        this.$toast.success({
                            duration: 1000,
                            forbidClick: true,
                            message: '驳回成功'
                        });
                        window.refreshList = true;
                        setTimeout(() => {
                            if (window.history.length == 1) {
                                // this.REPLACE({ name: 'approve' });
                                window.closeWindow();
                            } else {
                                this.GO(-1);
                            }
                        }, 1000);
                    } else {
                        this.$toast.fail({
                            duration: 1000,
                            forbidClick: true,
                            message: response.rspMsg
                        });
                    }
                }).catch((error) => {
                    console.log(error);
                    this.$toast.clear();
                    this.$toast.fail({
                        forbidClick: true,
                        message: error.rspMsg || '网络异常'
                    });
                });
            },

            forcedEndConfirm(reason) {
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                var param = {
                    id: this.$route.query.id,
                    reason: reason
                };
                this.$http.post('badu/eaa/forceAgreeApproveWorkFlow_V2.do', param).then((response) => {
                    if (response.rspCode == 0) {
                        this.opinionRemind = '';
                        this.$toast.success({
                            duration: 1000,
                            forbidClick: true,
                            message: '强制完结成功'
                        });
                        window.refreshList = true;
                        setTimeout(() => {
                            if (window.history.length == 1) {
                                // this.REPLACE({ name: 'approve' });
                                window.closeWindow();
                            } else {
                                this.GO(-1);
                            }
                        }, 1000);
                    } else {
                        this.$toast.fail({
                            duration: 1000,
                            forbidClick: true,
                            message: response.rspMsg
                        });
                    }
                }).catch((error) => {
                    this.$toast.clear();
                    this.$toast.fail({
                        forbidClick: true,
                        message: error.rspMsg || '网络异常'
                    });
                });
            }
        }
    };
</script>

<style lang="scss"
       scoped>
    @import '../../assets/scss/approve.scss';
    @import '../../assets/scss/approve-create.scss';
</style>
